var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tray-badge",class:`tray-badge--${_vm.color} ${_vm.outlined && 'tray-badge__outlined'}`},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }